import Link from "next/link";
import ButtonBgAnimate from "../buttonBgAnimate/buttonBgAnimate";
import styles from "./customPlan.module.scss";
import Popup from "../popup/popup";
import { svgImages } from "@/lib/svgImages";
import { useState } from "react";

const CustomPlan = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <div className={`${styles["customPlan"]}`}>
        <div className={`${styles["left"]}`}>
          <div className={`${styles["title"]}`}>
            <h2 className="font-size-32">Custom Plan</h2>
          </div>
          <p className={`${styles["description"]}`}>
            The reliable, unmatched enterprise-grade solution your all-in-one
            platform for every link and QR Code need.
          </p>
          <div className={`${styles["button"]}`}>
            <ButtonBgAnimate
              title="Get a Qoute"
              url=""
              outline={false}
              onClick={handleOpen}
            />
          </div>
        </div>
        <div className={`${styles["right"]}`}>
          <div className={`${styles["note"]}`}>
            Everything in Enterprise plus:
          </div>
          <div className={`${styles["features"]}`}>
            <ul>
              <li>More QR Codes</li>
              <li>More Links</li>
              <li>Custom Layout Design</li>
              <li>Custom Features</li>
            </ul>
          </div>
        </div>
      </div>
      <Popup
        title="Custom Plan"
        subtitle="Everything in Enterprise plus:"
        content="More QR Codes, More Links, Custom Layout Design, Custom Features"
        icon={svgImages.qr_true}
        setOpenCard={setOpen}
        openCard={open}
      />
    </>
  );
};

export default CustomPlan;
